import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Columns, Column } from '@components/Columns';
import { Text } from '@components/typography';
import { Button } from '@components/Button';
import { themeSpace, themeColor, themeMediaQuery } from '@utils/styledTheme.util';
import { LoadingTextStyles, Display1Styles, BodyMobileTextStyles } from '@components/typography/interVariants';

export const SectionWrapper = styled(Flex)<{ background: string; backgroundMobile: string }>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: center;
  ${themeMediaQuery('below_sm')} {
    height: 84vh;
    min-height: 818px;
    justify-content: center;
    background-image: ${props => `url(${props.backgroundMobile})`}, linear-gradient(0deg, ${themeColor('black')} 50%, transparent);
  }
  ${themeMediaQuery('sm')} {
    position: relative;
    overflow: hidden;
    height: 51vw;
    background-image: ${props => `url(${props.background})`};
  }
  @media (min-width: 36rem) and (max-width: 52.063rem) {
    height: 109vh;
    background-position-y: bottom;
  }
`;

export const StyledColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding: 0px ${themeSpace(4)};
  }
`;

export const ContentColumn = styled(Column)`
  display: flex;
  justify-content: flex-start;
`;

export const StyledFlex = styled(Flex)`
  gap: calc(${themeSpace(5)} + ${themeSpace(1)});
  margin-top: ${themeSpace(6)};
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(5)};
  }
  ${themeMediaQuery('md')} {
    gap: ${themeSpace(7)};
    margin-top: ${themeSpace(7)};
  }
  @media screen and (min-width: 1400px) {
    margin-top: ${themeSpace(10)};
  }
  ${themeMediaQuery('lg')} {
    gap: calc(${themeSpace(9)} + ${themeSpace(1)});
  }
`;

export const StyledButton = styled(Button)`
  padding: 0 ${themeSpace(6)};
  border-radius: ${themeSpace(6)};
  ${themeMediaQuery('below_sm')} {
    height: 40px;
    line-height: 37px;
  }
`;

export const StyledTextTitle = styled(Text)`
  ${themeMediaQuery('below_sm')} {
    ${BodyMobileTextStyles};
    color: ${themeColor('actionPurple3')};
  }
  ${themeMediaQuery('sm')} {
    ${LoadingTextStyles};
  }
  ${themeMediaQuery('md')} {
    ${Display1Styles};
    font-size: 30px;
  }
  @media screen and (min-width: 1400px) {
    font-size: 28px;
    line-height: 33.6px;
  }
  @media (min-width: 36rem) and (max-width: 52.063rem) {
    ${LoadingTextStyles};
  }
`;

export const StyledText = styled(StyledTextTitle)`
  color: rgba(118, 118, 118, 1);
`;
